'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _TextareaAutosizeJs = require('./TextareaAutosize.js');

var _TextareaAutosizeJs2 = _interopRequireDefault(_TextareaAutosizeJs);

exports['default'] = _TextareaAutosizeJs2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-autosize-textarea/lib/index.js
 ** module id = ./node_modules/react-autosize-textarea/lib/index.js
 ** module chunks = 1
 **/